import { ReactElement } from "react";

import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";

import styles from "./NotesList.module.scss";

/**
 * A generic note which can be displayed and edited in a {@link NotesList}.
 */
interface NoteListItem {
    /**
     * A unique key for this item within the current list.
     */
    id: string;

    /**
     * The content of the note.
     */
    content: string;

    /**
     * The name of the user who wrote the note.
     */
    user: string;

    /**
     * When the note was written.
     */
    date: Date;
}

/**
 * The properties for a {@link NotesList} component.
 */
interface NotesListComponentProps {
    /**
     * The notes to show in the list.
     */
    notes: NoteListItem[];

    /**
     * Optional data tag used for testing
     */
    dataCy?: string;
}

/**
 * A component which shows a list of notes with their submitter names and dates.
 * @param props The component properties.
 */
function NotesList(props: Readonly<NotesListComponentProps>): ReactElement {
    return (
        <ul data-cy={props.dataCy}>
            {props.notes.map(note => (
                <li key={`notes-list-${note.id}`} className={styles["notes-list-item"]}>
                    <div>
                        <strong className="margin-xs-right">{note.user}</strong><time dateTime={`${note.date}`}>{LuxonDateHelper.formatToFullDateTime(note.date)}</time>
                    </div>
                    <div>
                        {JSXHelper.BreakStringIntoParagraphs(note.content)}
                    </div>
                </li>
            ))}
        </ul>
    );
}

export { NoteListItem, NotesList };
